import React from "react";
import "../Css/contact.css";
import Download from "../Assets/download.svg";

// A single pixel-art arrow (blocky rect-grid, same technique as the
// case-study card's arrow icon), pointing up by default — rotated per
// instance to build the 4-angle repeating pattern below.
function PixelArrowGlyph({ angle = 0 }) {
  return (
    <svg
      className="arrow-footer-glyph"
      viewBox="0 0 9 9"
      shapeRendering="crispEdges"
      xmlns="http://www.w3.org/2000/svg"
      style={{ "--arrow-angle": `${angle}deg` }}
      aria-hidden="true"
    >
      <rect x="4" y="0" width="1" height="1" fill="currentColor" />
      <rect x="3" y="1" width="1" height="1" fill="currentColor" />
      <rect x="5" y="1" width="1" height="1" fill="currentColor" />
      <rect x="2" y="2" width="1" height="1" fill="currentColor" />
      <rect x="6" y="2" width="1" height="1" fill="currentColor" />
      <rect x="4" y="3" width="1" height="5" fill="currentColor" />
    </svg>
  );
}

// A fixed 4x4 tile, matching the reference exactly: each row cycles the
// same 4 rotation steps (up, two diagonal steps, right).
const ARROW_PATTERN_ANGLES = [0, 30, 60, 90];
const ARROW_PATTERN_CELL_COUNT = 16;

function PixelArrowPattern() {
  return (
    <div className="arrow-footer-pattern" aria-hidden="true">
      {Array.from({ length: ARROW_PATTERN_CELL_COUNT }).map((_, i) => (
        <PixelArrowGlyph key={i} angle={ARROW_PATTERN_ANGLES[i % 4]} />
      ))}
    </div>
  );
}

function Contact() {
  return (
    <div className="footer-card">
      <div className="footer-top">
        <div className="footer-left">
          <span className="footer-tag">Have Something in Mind?</span>
          <h1 className="footer-heading">Let's Talk</h1>
          <a href="mailto:harshitsharma34@gmail.com" className="footer-email">
            harshitsharma34@gmail.com
          </a>
        </div>

        <div className="footer-image-placeholder">
          <PixelArrowPattern />
        </div>
      </div>

      <div className="footer-links-row">
        <ul className="social-list">
          <li>
            <a href="https://harshits.medium.com/" target="_blank" rel="noopener noreferrer">
              MEDIUM
            </a>
          </li>
          <li>
            <a href="https://contra.com/harshit_sharma29/work?r=harshit_sharma29" target="_blank" rel="noopener noreferrer">
              CONTRA
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/harshitsharma34/" target="_blank" rel="noopener noreferrer">
              LINKEDIN
            </a>
          </li>
          <li>
            <a href="https://twitter.com/bruisedwaynne" target="_blank" rel="noopener noreferrer">
              TWITTER
            </a>
          </li>
        </ul>

        <a href="https://drive.google.com/file/d/1jA679kx8i1zr_Mrol2NQ67I-1dmV_guF/view?usp=sharing" className="sticky-cta-btn filled" target="_blank" rel="noopener noreferrer">
          <img src={Download} alt="" className="btn-icon" />
          Download Resume
        </a>
      </div>

      <div className="footer-credit-row">
        <span>I Designed and Coded this website from scratch © Harshit Sharma.</span>
        <span>
          Made over a Cup of{" "}
          <span role="img" aria-label="coffee">☕</span> and alot of
          sleepless <span role="img" aria-label="moon">🌛</span>
        </span>
      </div>
    </div>
  );
}

export default Contact;